import { useQuery } from '@tanstack/react-query';
import {
  getTransmitterRawEventDetail,
  listTransmitterRawEvents,
} from '../api';
import type {
  TransmitterRawEventDetailKey,
  TransmitterRawEventsFilters,
} from '../types';

export const transmitterRawEventsKeys = {
  all: ['transmitter-raw-events'] as const,
  list: (filters: TransmitterRawEventsFilters) =>
    [...transmitterRawEventsKeys.all, 'list', filters] as const,
  detail: (key: TransmitterRawEventDetailKey) =>
    [...transmitterRawEventsKeys.all, 'detail', key] as const,
};

export function useTransmitterRawEvents(filters: TransmitterRawEventsFilters) {
  return useQuery({
    queryKey: transmitterRawEventsKeys.list(filters),
    queryFn: () => listTransmitterRawEvents(filters),
    staleTime: 30 * 1000,
  });
}

export function useTransmitterRawEventDetail(key: TransmitterRawEventDetailKey | null) {
  return useQuery({
    queryKey: key ? transmitterRawEventsKeys.detail(key) : [...transmitterRawEventsKeys.all, 'detail', 'empty'],
    queryFn: () => getTransmitterRawEventDetail(key!),
    enabled: !!key,
    staleTime: 30 * 1000,
  });
}
